import styles from './Coupon.module.scss';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { ICouponType } from '../Order/Order';
import MyPageNavigate from '../../components/MyPageNavigate/MyPageNavigate';
import { isDesktop } from 'react-device-detect';
import leftArrow from '../../assets/leftArrow02.png';
import LoginHandler from '../../components/LoginHandler/LoginHandler';
import { useTranslation } from 'react-i18next';

function Coupon() {
  const navigate = useNavigate();
  const [couponList, setCouponList] = useState<ICouponType[]>([]);
  useEffect(() => {
    axiosClient
      .get('/data/coupon')
      .then((res) => setCouponList(res.data.data.coupons));
  }, []);
  function dateFormatter(expireDate: string) {
    let date = new Date(expireDate);
    return (
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '.' +
      ('0' + date.getDate()).slice(-2) +
      ',' +
      date.getFullYear()
    );
  }
  const { t, i18n } = useTranslation();
  return (
    <div>
      <LoginHandler />
      <Header />
      <div className={styles.container}>
        {isDesktop && <MyPageNavigate />}
        <h3 className={styles.title}>
          {!isDesktop && (
            <img src={leftArrow} alt="leftArrow" onClick={() => navigate(-1)} />
          )}
          <span>{t('myPage.4')}</span>
        </h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            alert(t('other.14'));
          }}
          className={styles.addCouponForm}
        >
          <label>
            <span>{t('myPage.28')}</span>
            <input type="text" placeholder={`${t('myPage.29')}`} />
          </label>
          <button>{t('myPage.30')}</button>
        </form>
        <div className={styles.usableCouponListWrap}>
          <h4>
            {t('myPage.31')}{' '}
            <span>
              {
                couponList.filter(
                  (coupon) =>
                    coupon.status == 'N' &&
                    new Date(coupon.expire_date) >= new Date(),
                ).length
              }
            </span>{' '}
          </h4>
          <ul className={styles.usableCouponList}>
            {couponList
              .filter(
                (coupon) =>
                  coupon.status == 'N' &&
                  new Date(coupon.expire_date) >= new Date(),
              )
              .map((coupon) => (
                <li key={coupon.id}>
                  <span>{coupon.coupon_name}</span>
                  <span>Until {<>{dateFormatter(coupon.expire_date)}</>}</span>
                </li>
              ))}
          </ul>
        </div>
        <div className={styles.unusableCouponListWrap}>
          <h4>
            {t('myPage.32')}{' '}
            <span>
              {
                couponList.filter(
                  (coupon) =>
                    coupon.status == 'E' ||
                    new Date(coupon.expire_date) < new Date(),
                ).length
              }
            </span>{' '}
          </h4>
          <ul className={styles.unusableCouponList}>
            {couponList
              .filter(
                (coupon) =>
                  coupon.status == 'E' ||
                  new Date(coupon.expire_date) < new Date(),
              )
              .map((coupon) => (
                <li key={coupon.id}>
                  <span>{coupon.coupon_name}</span>
                  <span>Until {<>{dateFormatter(coupon.expire_date)}</>}</span>
                </li>
              ))}
          </ul>
        </div>
        <div className={styles.couponGuide}>
          <h4>{t('myPage.33')}</h4>
          <ul>
            <li>· {t('myPage.34')}</li>
            <li>· {t('myPage.35')}</li>
            <li>· {t('myPage.36')}</li>
            <li>· {t('myPage.37')}</li>
            <li>· {t('myPage.38')}</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Coupon;
